import type { BVH } from 'three/examples/jsm/loaders/BVHLoader.js';

import { noticesStore } from 'stores/global';

import {
  MOTION_EDITING_LONG_SOURCE_MOTION_MESSAGE,
  MOTION_EDITING_MAX_SOURCE_DURATION_SECONDS,
} from '../constants';

const warnedLongSourceMotionKeys = new Set<string>();

export function getSourceDurationSecondsFromBvh(
  bvh: BVH | null | undefined,
): number | null {
  const duration = bvh?.clip?.duration;
  if (duration == null || !Number.isFinite(duration) || duration <= 0) {
    return null;
  }

  return duration;
}

export function isMotionEditingSourceDurationSupported(
  durationSeconds: number | null | undefined,
): boolean {
  if (durationSeconds == null) {
    return true;
  }

  return durationSeconds <= MOTION_EDITING_MAX_SOURCE_DURATION_SECONDS;
}

export function buildLongSourceMotionWarningKey({
  sceneID,
  referenceName,
  timelineIndex,
}: {
  sceneID: string;
  referenceName: string;
  timelineIndex: number;
}) {
  return `${sceneID}:${referenceName}:${timelineIndex}`;
}

export function warnLongSourceMotionEditingIfNeeded({
  sceneID,
  referenceName,
  timelineIndex,
  sourceBvh,
  userKeyPoseCount,
}: {
  sceneID: string;
  referenceName: string;
  timelineIndex: number;
  sourceBvh: BVH | null | undefined;
  userKeyPoseCount: number;
}) {
  if (userKeyPoseCount > 0) {
    return;
  }

  const sourceDurationSeconds = getSourceDurationSecondsFromBvh(sourceBvh);
  if (isMotionEditingSourceDurationSupported(sourceDurationSeconds)) {
    return;
  }

  const warningKey = buildLongSourceMotionWarningKey({
    sceneID,
    referenceName,
    timelineIndex,
  });
  if (warnedLongSourceMotionKeys.has(warningKey)) {
    return;
  }

  warnedLongSourceMotionKeys.add(warningKey);
  noticesStore.warning(MOTION_EDITING_LONG_SOURCE_MOTION_MESSAGE);
}
